seedWebApp.controller('ContactDashboardCtrl', ['$scope', 'UserSettingService', 'StoreService', '$location', '$routeParams', 'ToastService', '$uibModal','AllocService', 'WorkflowService','TranslationService', 'DocService',
    function ($scope, UserSettingService, StoreService, $location, $routeParams, ToastService, $uibModal, AllocService, WorkflowService, TranslationService, DocService) {
        console.log('ContactDashboardCtrl');
        $scope.translation = TranslationService.getActiveTranslation();

        $scope.selectedIndex = $routeParams.Tab;
        $scope.tabSelected = function (pageIndex) {
            $location.search('Tab', pageIndex);
            $scope.selectedIndex = pageIndex;
        };

        var favorites = [];        
        $scope.dash = {
            //selectedSkuID: 'XXXXX' ,
            selectedSkuID: null,
            selProduct: null,
            items: [],
            quotes: [],
            adders: [],
            logistics: [],
            favorites: favorites,
            currencySymbol: 'US$',
        };

        $scope.goBack = function () {
            //$location.path('/Home/');
            //window.history.back();
            var dashTab = 1;
            console.log('goBack ' + dashTab, $scope.selectedIndex);
            $location.path('/Dashboard/').search('Tab', dashTab);
            //$location.search('');
        };
        

        $scope.loadContactOrders = function (contactID) {
            $scope.loading = true;
            //, '', [], 0, 100, { "column": "","reverse": false}
            StoreService.getContactDashboard(contactID)
                .then(function (result) {
                    $scope.loading = false;          
                    $scope.contactName = result.data.ContactName;
                    $scope.contactCode = result.data.ContactCode;
                    $scope.countryID = result.data.CountryID;
                })
                .catch(function (errorDescription) {
                    $scope.loading = false;
                    $scope.error = true;
                    $scope.errorDescription = errorDescription;
                    ToastService.createToast('Erro ao carregar clientes', '', 8000, 'error');
                });
        };

        
        //LOAD CONTACT DATA
        $scope.ContactID = $routeParams.id;
        if (!$scope.ContactID) {
            $scope.ContactID = '';
        }
        else {
            //$scope.loadFavorites($scope.ContactID);
            $scope.loadContactOrders($scope.ContactID);
        }

        
        $scope.createCart = function (contactID) {
            //console.log('createCart');
            if (!$scope.cartOrder) {
                var item = {
                    OrderID: 'NEW_QUOTE',
                    ContactID: contactID,
                    ContactName: contactID,
                    ReservationDate: new Date(),
                    StatusID: WorkflowService.getStatusNewQuote(),
                    Details: [],
                    TotalQuantity: 0
                };
                $scope.cartOrder = item;
            }
        };
        $scope.createCart($scope.ContactID);
        
        $scope.addCartProduct = function (cartOrder, cartProduct) {
            console.log('inserindo cartProduct, SÓ MOSTRA SEQUENCIAS X00')
            return StoreService.addCartProduct(cartOrder, cartProduct, $scope.dash.currencySymbol);            
        };

        $scope.removeCart = function (cartProduct) {
            //cartProduct.Quantity = null;
            if (cartProduct.QtBoxes > 1) {
                cartProduct.QtBoxes--;
                return;
            }

            for (var i in $scope.cartOrder.Details) {
                var det = $scope.cartOrder.Details[i];
                if (det.SkuID == cartProduct.SkuID) {
                    $scope.cartOrder.Details.splice(i, 1);
                    ToastService.createToast('Produto removido', cartProduct.SkuID, 2000, 'warning');
                }
            }
        };

        $scope.addCart = function (contactID, cartProduct) {
            console.log('doAddOrder ' + contactID);
            console.log(cartProduct);
            //cartProduct.isSelected = true;
            cartProduct.Quantity = 1;
            if ($scope.addCartProduct($scope.cartOrder, cartProduct)) {
                ToastService.createToast('Produto adicionado', cartProduct.SkuID, 2000, 'success');
            }                        
        };

       

        $scope.openCart = function () {
            console.log('openCart');
            var modalInstance = StoreService.openOrderDetailModal(null, $scope.ContactID, $scope.cartOrder);
            modalInstance.result.then(
                function () {
                    console.log('CARRINHO INSERIDO, ZERAR CARRINHO');

                    $scope.$broadcast("clearProducts");
                    $scope.cartOrder = null;
                    $scope.createCart($scope.ContactID);
                    $scope.refreshQuotes();
                }
            );
        };

        $scope.openDetail = function (item) {
            StoreService.openOrderDetailModal(item.OrderID);
        };     

        $scope.getExpiredClass = function (expDate) {
            return AllocService.getExpiredClass(expDate);
        };


        $scope.canShowExpirationDate = function (item) {
            return WorkflowService.canShowExpirationDate(item);
        };

        $scope.getImage = function (country) {
            return StoreService.getCountryImage(country);
        };
       

        $scope.refreshQuotes = function () {
            //$scope.loadQuotes($scope.ContactID);
            console.log('refreshQuotes CONTACT');
        };

        $scope.showDrawing = function (drawingID) {
            DocService.showDrawing($scope, drawingID);
        };


    }]
);